"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _react = _interopRequireWildcard(require("react"));

var _icons = require("@ant-design/icons");

var _reactRouterDom = require("react-router-dom");

var _antd = require("antd");

var _IntlMessage = _interopRequireDefault(require("../../../components/util-components/IntlMessage"));

var _NavigationConfig = _interopRequireDefault(require("../../../configs/NavigationConfig"));

function getOptionList(navigationTree, optionTree) {
  optionTree = optionTree ? optionTree : [];

  var _iterator = (0, _createForOfIteratorHelper2.default)(navigationTree),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var navItem = _step.value;

      if (navItem.submenu.length === 0) {
        optionTree.push(navItem);
      }

      if (navItem.submenu.length > 0) {
        getOptionList(navItem.submenu, optionTree);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return optionTree;
}

var optionList = getOptionList(_NavigationConfig.default);

var getCategoryIcon = function getCategoryIcon(category) {
  switch (category) {
    case 'dashboards':
      return /*#__PURE__*/_react.default.createElement(_icons.DashboardOutlined, {
        className: "text-success"
      });

    case 'apps':
      return /*#__PURE__*/_react.default.createElement(_icons.AppstoreOutlined, {
        className: "text-danger"
      });

    case 'components':
      return /*#__PURE__*/_react.default.createElement(_icons.AntDesignOutlined, {
        className: "text-primary"
      });

    case 'extra':
      return /*#__PURE__*/_react.default.createElement(_icons.FileTextOutlined, {
        className: "text-warning"
      });

    default:
      return null;
  }
};

var searchResult = function searchResult() {
  return optionList.map(function (item) {
    var category = item.key.split('-')[0];
    return {
      value: item.path,
      label: /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: item.path
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-list-item"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "icon"
      }, getCategoryIcon(category)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "font-weight-semibold"
      }, /*#__PURE__*/_react.default.createElement(_IntlMessage.default, {
        id: item.title
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "font-size-sm text-muted"
      }, category, " "))))
    };
  });
};

var SearchInput = function SearchInput(props) {
  var active = props.active,
      close = props.close,
      isMobile = props.isMobile,
      mode = props.mode;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      options = _useState4[0],
      setOptions = _useState4[1];

  var inputRef = (0, _react.useRef)(null);

  var onSelect = function onSelect() {
    setValue('');
    setOptions([]);

    if (close) {
      close();
    }
  };

  var onSearch = function onSearch(searchText) {
    setValue(searchText);
    setOptions(!searchText ? [] : searchResult(searchText));
  };

  var autofocus = function autofocus() {
    inputRef.current.focus();
  };

  if (active) {
    autofocus();
  }

  return /*#__PURE__*/_react.default.createElement(_antd.AutoComplete, {
    ref: inputRef,
    className: "nav-search-input ".concat(isMobile ? 'is-mobile' : '', " ").concat(mode === 'light' ? 'light' : ''),
    dropdownClassName: "nav-search-dropdown",
    options: options,
    onSelect: onSelect,
    onSearch: onSearch,
    value: value,
    filterOption: function filterOption(inputValue, option) {
      return option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Search...",
    prefix: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, {
      className: "mr-0"
    })
  }));
};

var _default = SearchInput;
exports.default = _default;